import { Autocomplete, GroupedSelectOption, LoadingBubbles, SelectOption } from '@scaleaq/scaleui';
import { Control, Controller, FieldValues, Path, RegisterOptions } from 'react-hook-form';

type ControlledAutoCompleteProps<T extends FieldValues, V> = {
  options: Array<SelectOption<V> | GroupedSelectOption<SelectOption<V>>>;
  label: string;
  name: Path<T>;
  control: Control<T>;
  render?: boolean;
  isLoading?: boolean;
  isMulti?: boolean;
  isClearable?: boolean;
  caution?: boolean | string;
  critical?: boolean | string;
  rules?: Omit<
    RegisterOptions<T, Path<T>>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
  placeholder?: string;
};

export const ControlledAutoComplete = <T extends FieldValues, V>({
  label,
  name,
  control,
  options,
  render = true,
  isLoading,
  isMulti = false,
  caution,
  critical,
  rules,
  placeholder,
  ...rest
}: ControlledAutoCompleteProps<T, V>) => {
  if (!render) return;

  return (
    <Controller
      key={name}
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          {...rest}
          isMulti={isMulti}
          label={label}
          placeholder={placeholder}
          options={options}
          onChange={v => onChange(Array.isArray(v) ? v : [v])}
          value={value}
          width={'100%'}
          isLoading={isLoading}
          style={{
            color: 'var(--sui-text-neutral-100)',
            fontFamily: 'var(--sui-font-family-body)',
            fontWeight: 'var(--sui-font-weight-regular)',
            fontSize: 'var(--sui-font-size-medium)',
          }}
          components={{ LoadingIndicator: () => <LoadingBubbles /> }}
          caution={caution}
          critical={critical}
        />
      )}
    />
  );
};
